
export const addUnits = (value: string | number): string => {
  const units = typeof value === 'number' ? 'px' : ''
  return `${value}${units}`
}